<div class="sectionTop">
  <div class="header-content">
    <img src={{mainState.sectionTop.globalHeader[0].iconPath}} alt="My Toyota Icon" class="header-icon" tabindex="0">
  </div>
</div>

<div class="contact-us-form">
  <div class="contact-us--page-heading">
    <h1>{{state?.pageHeading}}</h1>
    <hr>
    <p class="sub-heading">
      {{state?.pageSubHeading}}
    </p>
  </div>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit() ">
    <div>
      <h2 class="heading">{{state?.sectionTopHeading}}</h2>
    </div>
    <div class="row gy-4">
      <div *ngFor="let field of state.sectionTopData" class="col-md-6 col-sm-12 col-xs-12 sectionTop-input-section pe-3">
        <label [for]="field.id">{{ field.label }}<span *ngIf="field.isRequired">*</span></label>
        <ng-container [ngSwitch]="field.type">
          <ng-container *ngSwitchCase="'text'">
            <input *ngIf="field.label !== 'Phone'" [type]="field.type" [id]="field.id" [formControlName]="field.id"
              [placeholder]="field.placeholder" [required]="field.isRequired">
            <input *ngIf="field.label === 'Phone'" maxlength="13" [type]="field.type" [id]="field.id"
              [formControlName]="field.id" [placeholder]="field.placeholder" [required]="field.isRequired"
              (input)="numbersOnlyValidator($event)">
          </ng-container>
          <input *ngSwitchCase="'email'" [type]="field.type" [id]="field.id" [formControlName]="field.id"
            [placeholder]="field.placeholder"
            [required]="field.isRequired" >
          <div *ngSwitchCase="'select'">
            <mat-select disableOptionCentering yPosition="below" [id]="field.id" aria-label="field.label"
              aria-disabled="false" disableRipple tabindex="0" [formControlName]="field.id"
              aria-placeholder="field.placeholder" [placeholder]="field.placeholder"> <ng-container
                *ngIf="field.label==='Country'">
                <mat-option *ngFor="let country of countries" [value]="country.value">
                  {{ country.label }}
                </mat-option>
              </ng-container>
              <ng-container *ngIf="field.label==='State'">
                <mat-option *ngFor="let state of filteredStates" [value]="state.value">
                  {{ state.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </div>
        </ng-container>
        <ng-container *ngIf="field.id !== 'email'">
          <div class="contact-us-error" *ngIf="userForm.get(field.id)?.invalid && userForm.get(field.id)?.touched">
            {{ field.errorMsg }}
          </div>
        </ng-container>
        <ng-container *ngIf="field.id === 'email'">
          <span class="contact-us-error"
            *ngIf="userForm.get(field.id)?.touched  && userForm.get(field.id)?.errors?.['required']">
            {{field.errorMsg}}
          </span>
          <span class="contact-us-error"
            *ngIf="userForm.get(field.id)?.touched && userForm.get(field.id)?.errors?.['pattern']">
            Enter a valid email address
          </span>
        </ng-container>

      </div>
    </div>

    <hr class="below-section-top">
    <div>
      <h2 class="heading">{{state?.sectionBottomHeading}}</h2>
    </div>
    <div class="row gy-4">
      <div class="col-md-6 col-sm-12 sectionTop-input-section">
        <label for="reason">{{state.sectionBottom.dropdownLabel}}<span
            *ngIf="state.sectionBottom.isRequired">*</span></label>
        <div class="dropdown">
          <button type="button" class="dropdown-toggle" [ngClass]="!selectedReason?'placeholderClass':''"
            (click)="toggleMenu()">
            <span class="selected-option">{{selectedReason || 'Select Reason'}}</span> <span class="arrow"><img
                [src]="arrowDownOrange"></span>
          </button>
          <div *ngIf="isOpen" class="dropdown-menu">
            <div class="dropdown-options-container" (scroll)="onScroll()">
            <div *ngFor="let item of deviceBasedDropDownData" (click)="toggleSubMenu(item,true)" class="dropdown-item">
              <div class="main-item" [ngClass]="isMobileView && item.isOpen ? 'isMobile' :'' ">
                <span *ngIf="item.subMenu.length > 0 && isMobileView && item.isOpen" class="arrow"><img
                    [src]="arrowLeft"></span>
                {{ item.label }}
                <span *ngIf="item.subMenu.length > 0 && !item.isOpen" class="arrow"><img [src]="arrowRight"></span>
                <span *ngIf="item.subMenu.length > 0 && !isMobileView && item.isOpen" class="arrow"><img
                    [src]="arrowLeft"></span>
                <div *ngIf="item?.isOpen" class="sub-menu" [ngClass]="isScrollHappend ? 'sub-menu-position' : '' ">
                  <div *ngFor="let sub of item.subMenu" class="sub-item" (click)="selectSubmenu(sub)">
                    {{ sub.label }}
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div *ngIf="userForm.get('reason')?.invalid && userForm.get('reason')?.touched" class="contact-us-error">
          {{state.sectionBottom.errorMsg}}</div>
      </div>

      <div class="col-md-6 col-sm-12 sectionTop-input-section" *ngIf="displayReasonInput">
        <label for="reasonInput">{{subReasonLables.label}}</label>
        <input [id]="'reasonInput'" [formControlName]="'reasonInput'" [placeholder]="subReasonLables.placeholder">
      </div>
    </div>

    <div class="contact-us-form--section-bottom--comments">
      <label for="comments">{{state.comments.label}}<span *ngIf="state.comments.isRequired">*</span></label>
      <textarea [id]="state.comments.id" [formControlName]="state.comments.id"
        [placeholder]="state.comments.placeholder" [required]="state.comments.isRequired"></textarea>
    </div>
    <div class="contact-us-error comment-error "
      *ngIf="userForm.get(state.comments.id)?.invalid && userForm.get(state.comments.id)?.touched">
      {{ state.comments.errorMsg }}
    </div>
  </form>
</div>
<div class="contact-us-button-container">
  <div class="--bottom-container">
    <div class="--bottom-left-container"></div>
    <div class="button-right-container">
      <kng-button [state]="state.buttons.submit" (clicked)="onSubmit()">
      </kng-button>
    </div>
  </div>

</div>

<div class="loader" *ngIf="state.loading">
  <kng-loader [state]="loaderState"></kng-loader>
</div>

<kng-footer [state]="mainState.sectionBottom.footer"></kng-footer>
